import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { CompanyDetail } from '@/features/company-detail'

const companyDetailSearchSchema = z.object({
  tab: z.enum(['overview', 'tech', 'enrichment', 'raw', 'similar', 'jobs', 'experiences']).optional(),
})

export type CompanyDetailSearchParams = z.infer<typeof companyDetailSearchSchema>

export const Route = createFileRoute('/_authenticated/companies/$uid/')({
  validateSearch: companyDetailSearchSchema,
  component: CompanyDetail,
})
